import { useForm } from 'react-hook-form';

import { generateDataLayerContact } from '@/src/utils/seo/analytics';

export type IContactFormSchema = {
  email: string;
  message: string;
  cgu: boolean;
};

export const useContactForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<IContactFormSchema>({
    defaultValues: {
      email: '',
      message: '',
      cgu: false,
    },
  });

  const handleSendEmail = handleSubmit(data => {
    window.dataLayer?.push(generateDataLayerContact());
    window.location.href = `mailto:hello@gomoworld.com?subject=Contact%20Form&body=${encodeURIComponent(
      `Email: ${data.email}\n\nMessage: ${data.message}`
    )}`;
  });

  return { register, handleSendEmail, errors, isValid };
};
